export default __webpack_public_path__ + "static/media/DanskeNarrowSemibold.9ed65a33.eot";